import { css } from "@emotion/react";

import tokens from "~/packages/design-tokens/dist/tokens";

export const listItemCss = css({
  padding: "0 12px 0 16px",
  "&:hover": {
    backgroundColor: tokens.color.bg.primary.hover.value,
  },
  "&[data-is-selected='true']": {
    backgroundColor: tokens.color.bg.primary.hover.value,
  },
});
